module.exports = "/_next/static/images/verwarming-a17772eefebfb544a83166f512f369a5.jpg";